<template>
  <div class="account-security">
    <div class="confirm-tip-modal" v-show="showTipModal"></div>
    <div class="view-title">
      <translate>Account Security</translate>
    </div>
    <div class="m-h-200" v-if="loading" v-loading="loading"></div>
    <div class="content" v-if="!loading">
      <div class="security-item">
        <div class="account-ip item-deteil">
          <p>
            <span class="item-name">
              <translate>Last Login Time:</translate>
            </span>
            <span>{{accountInfo.last_login_time * 1000 | moment('YYYY-MM-DD HH:mm:ss')}}</span>
          </p>
          <p>
            <span class="item-name">
              <translate>Last Login IP:</translate>
            </span>
            <span>{{accountInfo.last_login_ip}}</span>
          </p>
          <el-button class="change-password" @click.stop="onChangePassword()">
            <translate>Change Password</translate>
          </el-button>
        </div>
        <div class="item-deteil">
          <p>
            <span class="item-name">
              <translate>Bind Mobile</translate>
            </span>
            <span class="item-msg" v-if='accountInfo.mobile'>
              <translate>You have bound</translate> {{accountInfo.mobile | telNumberFormat}}
            </span>
            <span class="item-msg" v-if='!accountInfo.mobile'>
              <translate>Unbound phone number</translate>
            </span>
            <el-button type="text" class="btn-text" @click.stop="onShowChangeMobile()">
              {{accountInfo.mobile ? attrText.change : attrText.bindMobile}}
            </el-button>
          </p>
          <p>
            <span class="item-name">
              <translate>Virtual MFA</translate>
            </span>
            <span class="item-msg">{{accountInfo.otp_enabled ? attrText.enabled : attrText.unopened}}</span>
            <el-button type="text" class="btn-text" @click.stop="onMfaOpen()">
              {{accountInfo.otp_enabled ? attrText.close : attrText.open}}
            </el-button>
          </p>
        </div>
      </div>
    </div>

    <component :is="currentRightPanel" :items="rightPanelData" @onClosePanel="onClosePanel" @callback="getAccountInfo"></component>

  </div>
</template>

<script>
  import STORE_CONST from '../../store/consts'
  import {PasswordStrengthMessage} from '../../config'
  import AccountChangeMobile from './model/account-change-mobile'
  import AccountChangePassword from './model/account-change-password'
  import AccountMfaOpen from './model/account-open-mfa'
  import AccountMfaClose from './model/account-close-mfa'
  export default{
    data () {
      return {
        loading: true,
        accountInfo: {},
        currentRightPanel: null,
        rightPanelData: null,
        showTipModal: false
      }
    },
    computed: {
      attrText () {
        return this.getAttrText()
      }
    },
    created () {
      if (Object.isEmpty(this.$store.getters.account)) {
        this.$store.dispatch(STORE_CONST.ACCOUNT.CURRENT).then(res => {
          this.getAccountInfo(res.id)
        })
      } else {
        console.log('getters.account', this.$store.getters.account)
        this.accountInfo = this.$store.getters.account
        this.getAccountInfo(this.$store.getters.account.id)
      }
    },
    methods: {
      // 提取翻译文本
      getAttrText () {
        return {
          change: this.$gettext('Change'),
          bindMobile: this.$gettext('Bind Mobile'),
          enabled: this.$gettext('Enabled'),
          unopened: this.$gettext('Unopened'),
          close: this.$gettext('Off'),
          open: this.$gettext('On')
        }
      },
      // 获取用户信息
      getAccountInfo (id) {
        this.$store.dispatch(STORE_CONST.ACCOUNT.GET_SUCH_ACCOUNT, id).then((res) => {
          this.loading = false
          this.accountInfo = Object.assign({}, this.accountInfo, res)
          console.log('accountInfo', this.accountInfo)
          if (this.$route.query.changePwd && this.$store.getters.team.setting.password_strength && this.$store.getters.account.password_strength.password_ok !== undefined && this.$store.getters.account.password_strength.password_ok === false) {
            this.$nextTick(() => {
              this.showTipModal = true
              this.onChangePassword()
            })
          }
        }, () => {
          this.loading = false
        })
      },
      onMfaOpen () {
        this.accountInfo.otp_enabled ? this.onCloseMfa() : this.onOpenMfa()
      },
      // 显示修改手机号
      onShowChangeMobile () {
        const time = !this.currentRightPanel || this.currentRightPanel.name === 'AccountChangeMobile' ? 0 : 300
        this.currentRightPanel = AccountChangeMobile
        this.$nextTick(() => {
          setTimeout(() => {
            this.rightPanelData = Object.clone(this.accountInfo)
          }, time)
        })
      },
      // 开启mfa
      onOpenMfa () {
        const time = !this.currentRightPanel || this.currentRightPanel.name === 'AccountMfaOpen' ? 0 : 300
        this.currentRightPanel = AccountMfaOpen
        this.$nextTick(() => {
          setTimeout(() => {
            this.rightPanelData = Object.clone(this.accountInfo)
          }, time)
        })
      },
      // 关闭mfa
      onCloseMfa () {
        const time = !this.currentRightPanel || this.currentRightPanel.name === 'AccountMfaClose' ? 0 : 300
        this.currentRightPanel = AccountMfaClose
        this.$nextTick(() => {
          setTimeout(() => {
            this.rightPanelData = {
              'first_code': {
                label: this.$gettext('Security Code'),
                val: '',
                rule: [
                  {
                    required: true, pattern: /^\d{6}$/, message: this.$gettext('Enter the 6-digit security code'), trigger: 'blur'
                  }
                ]
              }
            }
          }, time)
        })
      },
      // 修改密码
      onChangePassword () {
        const time = !this.currentRightPanel || this.currentRightPanel.name === 'AccountChangePassword' ? 0 : 300
        this.currentRightPanel = AccountChangePassword
        this.$nextTick(() => {
          setTimeout(() => {
            this.rightPanelData = []
          }, time)
        })
      },
      // 关闭右侧侧滑
      onClosePanel () {
        console.log('--closed panel--')
        this.currentRightPanel = null
        this.rightPanelData = null
        var passwordOk = this.$store.getters.account.password_strength ? (this.$store.getters.account.password_strength.password_ok !== undefined && this.$store.getters.account.password_strength.password_ok === false) : false
        if (this.currentRightPanel == null && this.$store.getters.team.setting.password_strength && passwordOk) {
          const h = this.$createElement
          const level = this.$store.getters.team.setting.password_strength
          this.showTipModal = false
          this.$msgbox({
            title: this.$gettext('prompt'),
            center: true,
            showClose: false,
            showCancelButton: false,
            closeOnClickModal: false,
            confirmButtonText: this.$gettext('Change Password'),
            customClass: 'password_strength_modal',
            beforeClose: (action, instance, done) => {
              this.onChangePassword()
              done()
              this.showTipModal = true
            },
            message: h('p', null, [
              h('p', { style: 'margin-bottom: 20px;' }, this.$gettext('Your current login password complexity does not meet the password strength requirements set by the team administrator. Please change the password before continuing to use.')),
              h('p', null, this.$gettext(PasswordStrengthMessage[level]))
            ])
          })
        }
      }
    },
    components: {
      AccountChangePassword,
      AccountChangeMobile,
      AccountMfaOpen,
      AccountMfaClose
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">
  @import "../../assets/css/variable";
  
  .account-security {
    color: $textColor;
    .m-h-200{
      min-height: 200px;
    }
    .confirm-tip-modal{
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1;
      background-color: rgba(0, 0, 0, 0.5);
      transition: all 1.3s;
      opacity: 1;
    }
    .right-panel{
      box-shadow: none;
    }
    .content {
      padding: 15px;
      .account-ip {
        border-bottom: 1px solid $border-color;
      }
      .security-item {
        padding: 0 20px;
        background-color: #fff;
        .item-deteil {
          position: relative;
          padding: 10px 0;
          p {
            line-height: 30px;
            .item-name {
              display: inline-block;
              margin-right: 20px;
              width: 120px;
              text-align: right;
            }
            .btn-text {
              margin-left: 20px;
            }
          }
        }
        .change-password {
          position: absolute;
          bottom: 10px;
          right: 0;
        }
      }
    }
    .detail-wrapper {
      height: 100%;
      .detail-desc {
        padding: 0 30px;
        margin-top: 20px;
      }
      .el-form {
        padding-top: 20px;
      }
      .el-form-item {
        .el-form-item__label {
          &:before {
            content: '';
          }
        }
      }
      .el-form-item__content {
        .el-input {
          .el-input__inner {
            border-radius: 0;
          }
        }
      }
      .detail-btn {
        position: absolute;
        bottom: 0;
        right: 0;
        padding: 0 30px;
        width: 100%;
        border: 1px solid $border-color;
        .btn-wrapper {
          padding: 15px 0;
          text-align: center;
          .el-button {
            padding: 10px 30px;
            border-radius: 0;
          }
        }
      }
      /*下一步后的样式*/
      .el-tabs__content {
        position: static;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// account-security.vue?45982330